import apiClient from "./apiClient";

export interface ActivityLog {
  id: number;
  userId: number;
  action: string;
  description: string;
  ipAddress: string;
  userAgent: string;
  createdAt: string;
  user: {
    id: number;
    ownerName?: string;
    email: string;
  };
}

export interface ActivityLogsResponse {
  logs: ActivityLog[];
  pagination: {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    itemsPerPage: number;
  };
}

export const activityLogService = {
  getActivityLogs: async (params: {
    page?: number;
    limit?: number;
  }): Promise<ActivityLogsResponse> => {
    const response = await apiClient.get("/activity-logs", { params });
    return response.data;
  },
};
